import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../../tools/contextLib';
import  EventScheduler  from './eventSchedule/eventScheduler';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Form, Label, Input, FormGroup, Button, AccordionItem, AccordionHeader, AccordionBody, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Table, Tooltip, Accordion } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import moment from 'moment';
import LoadingSpin from "react-loading-spin";
import { dotStream, hourglass } from 'ldrs'
import { connect } from 'react-redux';

dotStream.register();
hourglass.register();

class Scheduling extends Component {

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            loading: false,
            sortByData: ["Department A->Z", "Department Z->A", "Event A->Z", "Event Z->A"], //I could've made this spelled out in the JSX <option> tags, but this way if we ever need to make this
                                                                                            //parameter data-driven from the database all I need to do is write this to be overwritten by the fetch
                                                                                            //so half of my work will already have been done
            //termData: [",", "."],
            termData: [],
            //deptData: [",", "."],
            deptData: [],
            //createdByData: ["Me", "System", "Me + System"],//This is in service of a parameter that no longer is being used, but it's being left here in case we need to revive it.
                                                            //Odds are low, but not zero.
            //statusData: [",", "."],
            statusData: [],
            //accordionData: [",", "."],
            accordionData: [],
            accordionHeaderData: [],
            accordionVisible: false,
            yeartermChoice: "",
            deptChoice: "",
            activeDepartment: "",
            //availableEvents: [",", "."],
            availableEvents: [],
            validSubtypes: ["Please select an event"],
            activeYT: "",
            lastFilter: [],
            submittedFlag: false,
            finalizeOption: false,
            finalizeModal: false,
            semesterEdit: false,
            editLockModal: false,
            confirmLockModal: false,
            confirmLockToSend: [],
            isFinalized: 0,
            availableDays: [],
            buildingList: [],
            roomManageModal: false,
            roomManagement: [],
            roomManageKey: 1,
            allInstructorList: [],
            tooltipOpen: false,
            openAccordion: [],
            theseAreLoading: [],
            activeData: [],
            updateKey: 1
        }
        this.getFilterOptions();
        
        this.modalToggle = this.modalToggle.bind(this);
        this.child = React.createRef();
    }

    async getUserInfo() { //Even though we're not going through all of the song and dance of validation and logging, we still need to know who this user is and in what capacity they're operating as
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
        });
        this.getFilterOptions();
    }

    async getFilterOptions() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('FilterOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            termData: data.term,
            deptData: data.department,
            statusData: data.status//From here, this will just be '...' and we'll fill it out with proper information later
        })
        var dept = this.props.userLevel;
        dept = dept.substring(0, dept.indexOf('-') - 1);
        this.setState({
            activeDepartment: dept
        })
        this.getDays();
        this.getBuildings();
        this.getAllInstructors();
    }

    async getDays() {//This function gets the list of days that a class can be scheduled for
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('GetDays', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            availableDays: data
        })
    }

    async getBuildings() {//This function gets a list of buildings that have academic rooms in them
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            buildCode: "ALL"
        }
        const response = await fetch('AcadBuildings', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            buildingList: data
        })
        //this.manageRoomType();
    }

    async getAllInstructors() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel
        }
        const response = await fetch('GetAllInstrSecSched', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            allInstructorList: data
        })
    }

    componentDidMount() {
        this.setState({
            returnable: this.props.reduxData.userInfo
        })
    }

    checkYTDept(e, type) {//The type parameter is necessary to know what kind of information we're getting, since this same function is used for both parameters.
                            //This function is used to determine whether the user has selected both year/term and department, and if they have to go get the status filter options
                            //If the user hasn't entered both and this is the first one, we'll need to save this selection anyway.
        let options = e.target.options;
        let value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        let dtString = value.join(',');
        if (type == "YT") {
            this.setState({
                yeartermChoice: e.target.value
            })
            if (this.state.deptChoice) {
                this.getStatusFilter(e.target.value, this.state.deptChoice);
            }
        }
        if (type == "DT") {
            this.setState({
                deptChoice: dtString
            })
            if (this.state.yeartermChoice) {
                this.getStatusFilter(this.state.yeartermChoice, dtString);
            }
        }
    }

    async getStatusFilter(YT, DT) {//This function takes the selected year/term and department values, and uses them to find what the available status options are for it
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            yeartermChoice: YT,
            deptChoice: DT
        }
        const response = await fetch('StatusOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            statusData: data
        })
    }

    async applyFilter(e) {
        this.setState({
            activeYT: this.state.yeartermChoice,
            loading: true
        })
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        //The Status and Department parameter values aren't so easily retrieved as the other two, given how they're multi-select we have to break them apart into a string SQL can understand
        //This if check to make sure we've entered everything could theoretically let through a query with no sort by value, but a sort by value is selected by default so accomplishing that
        //would be very hard for the user
        var loc = this.state.termData.filter(function (semester) { return semester.sortorder == dataInput.get('term') });
        if (dataInput.get('term') != "DEFAULT" && dataInput.get('department') != "DEFAULT" && dataInput.get('status') != "...") { 
            const statusString = dataInput.getAll('status').join(',');
            const deptString = dataInput.getAll('dept').join(',');
            if (dataInput.get('term') == null || dataInput.get('dept') == null || statusString == "") {
                return;
            }
            let toSend = {
                userLevel: this.props.userLevel,
                sortby: dataInput.get('sort'),
                term: dataInput.get('term'),
                department: deptString,
                status: statusString
            }
            this.setState({
                lastFilter: toSend//If we ever have to reprocess this filter in cases of when the user adds something and we need to display it immediately, we need to be able to remember what 
                                    //this filter is. this.state.lastFilter will have the values of the filter saved for later
            })
            const response = await fetch('Filter', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                loading: false,
                accordionData: data,
                accordionVisible: true,
                semesterEdit: loc[0].editable,
                isFinalized: data.filter(obj => obj.finalizedcount = 0).length
            })
            this.findIfDone();
            //let statList = []; //Here we detect whether we'll let Registrar see the option to finalize the term. The option should only be available if there aren't any events in Editing or Submitted mode
            //data.forEach((options) => {
            //    statList.push(options.status)
            //})
            //this.setState({
            //    statusList: statList
            //})
            //console.log("status list: " + JSON.stringify(statList));
            //if ((!statList.includes("Editing") && !statList.includes("Submitted")) || !statList.includes("FINALIZED")) {
            //    this.setState({
            //        finalizeOption: true
            //    })
            //}
        }
        //localStorage.setItem("lastFetch", moment());
        this.getEventOptions(dataInput.get('dept'));
    }

    async refreshAccordion(RefreshData) { //This function will be used when we need to reload the displayed information with the same search criteria. We can't use the other function because
                                            //that one's data entry relies on a form event and if we need to refresh this we haven't had a form event that contains the relevant data
        if (RefreshData.term != "DEFAULT" && RefreshData.department != "DEFAULT" && RefreshData.status != "...") {
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + this.props.reduxData.apiKey
            this.props.updateFetchTime();
            let toSend = {
                userLevel: this.props.userLevel,
                sortby: RefreshData.sortby,
                term: RefreshData.term,
                department: RefreshData.department,
                status: RefreshData.status
            }
            this.setState({
                lastFilter: toSend
            })
            const response = await fetch('Filter', {//We're using the same controller for this because what we need is the same information
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            this.setState({
                accordionData: data,
                accordionVisible: true,
                isFinalized: data.filter(obj => obj.finalizedcount = 0).length
            })
            this.findIfDone();
        }
        this.getEventOptions(RefreshData.department);
    }

    async getEventOptions(dept) { //This retrieves dropdown information for the Add a New Course Section menu
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            department: dept
        }
        const response = await fetch('GetEventOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            availableEvents: data
        })
        this.findIfDone();
    }

    async getSubtypes(e) { //This retrieves subtypes based on which event from the previous function you picked
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            eventid: e.target.value
        }
        const response = await fetch('GetSubtypeOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            validSubtypes: data
        })
    }

    async addSection(e) { //This is the go button that adds the specified section to the year/term that's being used.
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.props.userLevel,
            eventid: dataInput.get('eventid'),
            subtype: dataInput.get('subtype'),
            yearterm: this.state.activeYT
        }
        const response = await fetch('AddSection', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data.output == "lock") {
            this.setState({
                editLockModal: true
            })
        }
        else {
            this.setState({
                submittedFlag: data.output == "true" ? true : false
                })
        }
        this.refreshAccordion(this.state.lastFilter);
        setTimeout(() => {
            this.setState({
                submittedFlag: false
            })
        }, 5000)
    }

    actionRender = (refreshList) => { //This is a callback function from the child component that asks the parent to rerender the accordion list after an action was taken in the eventScheduler component
                                        //Once the user selects an action to change the event status, that change needs to be reflected on this level
        this.setState({
            accordionData: refreshList,
            accordionVisible: true
        })
        this.getStatusFilter(this.state.yeartermChoice, this.state.deptChoice);
        let statList = [];
        refreshList.forEach((options) => {
            statList.push(options.status)
        })
        this.findIfDone();
    }

    async findIfDone() { //If an action to change the status of an event makes it now legal to finalize the term, this function will find it
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.userLevel,
            currentTermSPID: this.state.activeYT
        }
        const response = await fetch('FinalizeLegal', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        if (data.finalizeflag == "true") {
            this.setState({
                finalizeOption: true
            })
        }
    }

    async bulkAction(input) { //Registrar will have the option to perform bulk actions to either approve all submitted or deny all submitted
        if (input.target.value == "Finalize") {
            let statList = [];
            this.state.accordionData.forEach((data) => {
                statList.push(data.status)
            })
            if (!statList.includes("Editing") && !statList.includes("Submitted")) {
                this.modalToggle();
                return; 
            }
        }
        let pkList = [];
        this.state.accordionData.forEach((data) => {
            pkList.push(data.pk)
        })
        let sendPKList = pkList.join(','); //We're getting a list of all visible events for approval or denial. This will scoop up everything shown regardless of status, but events that can't be
                                            //approved or denied won't be moved into Approved or Denied anyway
        let toSend = {
            userLevel: this.props.userLevel,
            action: input.target.value,
            targets: sendPKList
        }
        if (input.target.value == "Lock") {
            this.setState({
                confirmLockModal: true,
                confirmLockToSend: toSend
            })
            return;
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('Action', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
            this.setState({
                accordionData: [],
                accordionVisible: false
            })
            this.getFilterOptions();
        //window.location.reload(false);//Once again, I tried to do this like a normal person and I still have nightmares about what happened.   
    }


    findIfDoneProp = (dataFromChild) => {
        this.setState({
            finalizeOption: dataFromChild
        })
    }

    modalToggle() {
        this.setState({
            finalizeModal: !this.state.finalizeModal
        })
    }

    async finalize() { //This function doesn't have a proper procedure behind it yet, all it does for now is flip all of the Approved statuses to Finalized. The part that actually feeds Campus6_40
                        //with this data is coming soon.
        let toSend = {
            userLevel: this.props.userLevel,
            yearterm: this.state.lastFilter.term
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('FinalizeSched', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.modalToggle();
        this.refreshAccordion(this.state.lastFilter);
    }

    toggleLockModal() {
        this.setState({
            editLockModal: !this.state.editLockModal
        })
    }

    toggleConfirmLock() {
        this.setState({
            confirmLockModal: !this.state.confirmLockModal
            })
    }

    async confirmLock() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            confirmLockModal: false
        })
        const response = await fetch('Action', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(this.state.confirmLockToSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        //window.location.href = window.location.href; //UPDATE 20230327: Switching away from routing-based control over which main component is displayed means that this doesn't work well anymore.
        this.setState({
            accordionData: [],
            accordionVisible: false
        })
        this.getFilterOptions();
        this.props.refreshAll();
    }

    tooltipToggle() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        })
    }

    //////////////////SECTION SPECIFIC FUNCTIONS////////////////////////////

    //async getInstructors(idArray) { //This function retrieves the instructors that are associated with this event
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        eventpk: this.props.eventpk //So it turns out you can't name this 'event' since that's a reserved word in C# and the model class won't let you name a property that
    //    }
    //    const response = await fetch('EventInstructors', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        instructors: data
    //    })
    //    //this.getAvailableInstructors();
    //}

    //async getAvailableInstructors(idArray) { //This function populates the dropdown for instructors that can teach this class. The procedure only gets instructors that have taught before, but that's a 
    //    //concern for if/when someone brings it up
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        eventpk: this.props.eventpk
    //    }
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    const response = await fetch('InstructorOptions', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        availableInstructors: data
    //    })
    //}

    //async getScheduleRecords(idArray) {//This function gets the previously defined schedules for this event
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        eventpk: this.props.eventpk
    //    }
    //    const response = await fetch('EventSchedRecords', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        scheduleRecords: data
    //    })

    //}

    //async getNotes(idArray) {//This function gets the note value for the listed event
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        eventpk: this.props.eventpk
    //    }
    //    const response = await fetch('EventSchedNotes', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        notes: data
    //    })
    //}

    //async getAvailableActions() {//This function gets what actions can be taken on this event to populate the actions dropdown with
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        eventstatus: this.props.eventstatus
    //    }
    //    const response = await fetch('GetActions', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        actions: data
    //    })
    //}

    //async getTermDates() {//This function determines what the beginning and end dates are for the term we're working in (as defined by the term this event is listed in the database for)
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        term: this.props.eventpk
    //    }
    //    const response = await fetch('FindTermBrackets', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        currentTermDates: data
    //    })
    //}

    //async isEventDateExempt() { //If this event is a LEAD or EDUC 500 or 600 level class, it's exempt from the date restrictions of the term's beginning and end dates
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        userLevel: this.props.userData.level,
    //        eventpk: this.props.eventpk
    //    }
    //    const response = await fetch('CheckEventDateExempt', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    this.setState({
    //        eventDateExempt: data
    //    })
    //}

    ////////////////////END SECTION SPECIFIC FUNCTIONS//////////////////////

    async accordionToggle(id) {
        let idArray = id.split("|")
        //this.setState({
        //    eventDateExempt: data
        //})
        if (this.state.openAccordion.indexOf(id) <= -1) {
            this.setState({
                theseAreLoading: [...this.state.theseAreLoading, id]
            })
            //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let bearerVAR = "Bearer " + this.props.reduxData.apiKey
            this.props.updateFetchTime();
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                eventpk: idArray[0],
                eventstatus: idArray[1]
            }
            const response = await fetch('SecSchedEventData', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            //localStorage.setItem("lastFetch", moment());
            let loadList = this.state.theseAreLoading
            let index = loadList.indexOf(id)
            loadList.splice(index, 1);
            this.setState({
                openAccordion: [...this.state.openAccordion, id],
                theseAreLoading: loadList,
                activeData: [...this.state.activeData, data]
            })
        }
        else {
            let currList = this.state.openAccordion
            let index = currList.indexOf(id)
            currList.splice(index, 1);
            let dataList = this.state.activeData
            let dataIndex = dataList.indexOf(dataList.find((element) => element.sectionid == id))
            dataList.splice(dataIndex, 1);
            this.setState({
                openAccordion: currList,
                activeData: dataList
            })
        }
    }

    schedCallback = (fromChild) => {
        this.refreshContents(fromChild)
    }

    async refreshContents(pk) {
        let thisValue = this.state.openAccordion.filter(item => item.includes(pk))
        this.setState({
            theseAreLoading: [...this.state.theseAreLoading,thisValue[0]]
        })
        let eventInfo = thisValue[0].split("|")
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            eventpk: pk,
            eventstatus: eventInfo[1]
        }
        const response = await fetch('SecSchedEventData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        let withoutActive = this.state.activeData.filter(remove => remove.sectionid != thisValue[0])
        let loadList = this.state.theseAreLoading
        let index = loadList.indexOf(thisValue[0])
        loadList.splice(index, 1);
        this.setState({
            activeData: withoutActive.concat(data),
            updateKey: this.state.updateKey + 1,
            theseAreLoading: loadList
        })
    }

    accordionDisplay() {//The accordion shouldn't be displayed until after the filter is applied. Because this accordion needs to iterate through something, instead of managing that on top of
        //hidden divs, we just don't even have it there to hide until the fetch gives us something to iterate through.
        return (<Accordion stayOpen defaultActiveKey="0" style={{ visibility: this.state.accordionVisible == true ? 'visible' : 'hidden' }} open={this.state.openAccordion} toggle={(e) => this.accordionToggle(e)}>
            <AccordionItem hidden={!this.state.semesterEdit} >
                {/*The majority of this accordion will be iteratively generated based on the events that are returned. However, no matter what we have to display to the user, we will*/}
                {/*always need to give the user the option to add a new section to this term. Therefore, this accordion option is spelled out right at the beginning to give them that option.*/}
                <AccordionHeader targetId="createnew">
                    Add a Course Section...
                </AccordionHeader>
                <AccordionBody accordionId="createnew">
                    <div>
                        <Form className="d-flex" onSubmit={this.addSection.bind(this)}>
                            <FormGroup>
                                <Label>Event ID</Label>
                                <Input type="select" name="eventid" id="eventid" defaultValue="DEFAULT" onChange={this.getSubtypes.bind(this)}>
                                    <option disabled value="DEFAULT">Select Event...</option>
                                    {this.state.availableEvents.map(events => (
                                        <option>{events}</option>
                                        ))}
                                </Input>
                            </FormGroup>
                            &nbsp;
                            <FormGroup>
                                <Label>Subtype</Label>
                                <Input type="select" name="subtype" id="subtype" defaultvalue="DEFAULT">
                                    <option disabled value="DEFAULT">...</option>
                                    {this.state.validSubtypes.map(subtypes => (
                                        <option>{subtypes}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <Button type="submit" outline color="success">Add</Button>&emsp;<div style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }} /></div>
                        </Form>
                    </div>
                </AccordionBody>
            </AccordionItem>
            {/*Now that we've given the user the option to add new events, we'll loop through the events we currently have and make accordion items for them.*/}
            {this.state.accordionData.map(events => (
                <AccordionItem>
                    <AccordionHeader targetId={events.pk + "|" + events.status}>
                        <Table size="sm">
                             <tr>
                                <td  style={{ textAlign: 'left', width: 100}}><Badge pill color={events.badgecolor}>{events.status}</Badge></td>
                                <td style={{ textAlign: 'left', width: 400 }}>{events.eventid} {events.subtype}  SEC {events.sectionid}  ({events.deptname})
                                    {this.state.theseAreLoading.includes(events.pk + "|" + events.status) && <l-dot-stream size="55" speed="2.5" color="#86d3ff"></l-dot-stream >}</td>
                                <td  style={{ textAlign: 'left' }}>{events.credlimit}</td>
                                <td  style={{ textAlign: 'right'}}>{events.createinfo}</td>
                             </tr>
                        </Table>
                    </AccordionHeader>
                    <AccordionBody accordionId={events.pk + "|" + events.status}>
                        {/*Within the body is just the EventSchedule child component. We pass a number of props to this, but the most important one is the event PK. This identifies which record*/}
                        {/*in the StagingTable_Sections table this EventScheduler component needs to display, which makes the fetches within this component much simpler. The key prop is also critical,*/}
                        {/*as this one helps this component understand which child component needs to be associated with what.*/}
                        {this.state.activeData.filter((section) => section.sectionid == events.pk + "|" + events.status).length > 0 &&
                            <EventScheduler
                            eventData={this.state.activeData.filter((section) => section.sectionid == events.pk + "|" + events.status)}
                            eventpk={events.pk}
                            eventstatus={events.status}
                            key={this.state.updateKey}
                            reEvaluateAction={action => this.actionReevaluate = action}
                            actionRerender={this.actionRender}
                            activeFilter={this.state.lastFilter}
                            ref={this.child}
                            refreshFinal={this.findIfDoneProp}
                            editable={this.state.semesterEdit}
                            userData={this.props.reduxData.userInfo}
                            availableDays={this.state.availableDays}
                            availableBuildings={this.state.buildingList}
                            availableInstr={this.state.allInstructorList}
                            schedCallback={this.schedCallback}
                            />
                        }
                    </AccordionBody>
                </AccordionItem>
            ))}
        </Accordion>);
    }   

    render() {
        //<LoadingSpin size="30px" primaryColor="#86d3ff" />
        let displayAccord = <div></div>
        if (this.state.loading) {
            displayAccord = <l-hourglass size="56" speed="1.5" color="#86d3ff" bg-opacity="0.13"></l-hourglass>
        }
        if (this.state.accordionVisible == true) {
                displayAccord = this.accordionDisplay();
        } //Here we decide whether we want to display the accordion at all
        
    return (
        <div>
            <Modal isOpen={this.state.editLockModal} toggle={this.toggleLockModal.bind(this)}>
                <ModalHeader toggle={this.toggleLockModal.bind(this)}>ERROR: Semester Locked</ModalHeader>
                <ModalBody>
                    <div classname="tooltipLinebreakCustom">This semester has been edit locked. Please wait for the Registrar to unlock it before performing this action.</div>
                </ModalBody>
                <ModalFooter></ModalFooter>
            </Modal>
            <Modal isOpen={this.state.confirmLockModal} toggle={this.toggleConfirmLock.bind(this)}>
                <ModalHeader toggle={this.toggleConfirmLock.bind(this)}>Lock Semester</ModalHeader>
                <ModalBody>
                    <div className="tooltipLinebreakCustom">
                        Edit locking a semester will disallow any new sections from being added to the semester and will prevent un-deleting any deleted sections.<br />
                        Do you want to switch the edit lock on this semester?
                    </div>
                </ModalBody>
                <ModalFooter><Button color="primary" onClick={this.confirmLock.bind(this) }>Yes</Button>&emsp;<Button onClick={this.toggleConfirmLock.bind(this)}>Go Back</Button></ModalFooter>
            </Modal>
            <br />
            <Form className="d-flex" inline onSubmit={this.applyFilter.bind(this)}>
                <FormGroup >
                    <Label >Sort By<p /></Label>
                    <Input type="select" name="sort" id="sort" >
                        {this.state.sortByData.map(option => (
                            <option>{option}</option> 
                            ))}
                    </Input>
                </FormGroup>
                &nbsp;
                <FormGroup >
                    <Label >Year/Term<p /></Label>
                    <Input type="select" name="term" id="term"  defaultValue="DEFAULT" onChange={(e) => this.checkYTDept(e, "YT")}>
                        <option value="DEFAULT" disabled={true}>Please select...</option>
                        {this.state.termData.map(option => (
                            <option value={option.sortorder }>{option.yearterm}</option>
                        ))}
                    </Input>
                </FormGroup>
                &nbsp;
                <FormGroup >
                    <Label >Department<br /><div style={{ fontSize: 10 }}>(Hold CTRL for multi-select)</div></Label>
                    <Input type="select" name="dept" id="dept" multiple onChange={(e) => this.checkYTDept(e, "DT")}>
                        {this.state.deptData.map(option => (
                            <option value={option.codekey}>{option.deptname}</option>
                        ))}
                    </Input>
                </FormGroup>
                &nbsp;
                <FormGroup >
                    <Label >Status<br /><div style={{ fontSize: 10 }}>(Hold CTRL for multi-select)</div></Label>
                    <Input type="select" multiple name="status" id="status" >
                        {this.state.statusData.map(option => (
                            <option>{option}</option>
                        ))}
                    </Input>
                </FormGroup >
                &nbsp;
                <Button type="submit" color="success" outline size="sm" className={"w-15"} id="submit">Apply</Button>
                {/*<Tooltip target="submit" toggle={this.tooltipToggle.bind(this)} isOpen={this.state.tooltipOpen && this.state.deptChoice.includes("%")} color="red">This may take a very long time. Are you sure?</Tooltip>*/}
            </Form>
            <div className="rightAlignCustom" style={{ visibility: this.state.accordionVisible == true && this.state.activeDepartment == "REGISTRAR" ? 'visible' : 'hidden' }}>
                <div className="inlineCustom" style={{ visibility: this.state.accordionVisible == true && this.state.activeDepartment == "REGISTRAR" ? 'visible' : 'hidden' }}>
                <Input type="select" name="bulkAction" id="bulkAction" value="DEFAULT" onChange={this.bulkAction.bind(this)}>
                    <option value="DEFAULT">Global Actions...</option>
                    <option value="Approve">Approve These</option>
                    <option value="Deny">Deny These</option>
                    {this.state.isFinalized == 0 && <option value="Lock">{this.state.semesterEdit == true ? "L" : "Unl"}ock Semester</option>}
                        {this.state.finalizeOption == true && !this.state.semesterEdit && <option value="Finalize" >FINALIZE SEMESTER</option>}
                    </Input></div>
                <Modal isOpen={this.state.finalizeModal} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>Confirm</ModalHeader>
                    <ModalBody>
                        This action is irreversible and will immediately move all Approved sections into production.<p />
                        Are you sure you want to do this?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.finalize.bind(this)}>Yes</Button>
                        <Button color="secondary" onClick={this.modalToggle}>No</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <br />
            <br />
            <br />
            {displayAccord}
        </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Scheduling);